import { useEffect, useRef } from 'react';
import { usePushNotifications } from '@/Hooks/usePushNotifications';
import { userService } from '@/services/auth/userService.js';

/**
 * Inicializa push notifications quando o usuário está na homepage.
 * - Se o usuário já estiver logado ao montar (ex.: acabou de fazer login e foi redirecionado),
 *   inicia o fluxo de permissão na hora.
 * - Também escuta o evento 'userLoggedIn' para o caso de login com a Home já aberta.
 */
const runInit = async (loadConfig, registerDevice, hasInitialized) => {
  if (hasInitialized.current) return;
  hasInitialized.current = true;

  try {
    console.info('[push] 1/2 Carregando config...');
    await loadConfig();
    console.info('[push] 2/2 Config carregada, chamando registerDevice() — deve exibir prompt de permissão...');
    await registerDevice();
    console.info('[push] Dispositivo registrado com sucesso');
  } catch (error) {
    console.warn('[push] Falha ao inicializar push notifications:', error?.message ?? error, error);
    hasInitialized.current = false;
  }
};

const PushNotificationsInitializer = () => {
  const { loadConfig, registerDevice } = usePushNotifications(navigator.language);
  const hasInitialized = useRef(false);

  useEffect(() => {
    console.info('[push] PushNotificationsInitializer montado (homepage)');
    return () => console.info('[push] PushNotificationsInitializer desmontado');
  }, []);

  useEffect(() => {
    const handleUserLoggedIn = () => {
      console.info('[push] Evento userLoggedIn recebido');
      runInit(loadConfig, registerDevice, hasInitialized);
    };

    window.addEventListener('userLoggedIn', handleUserLoggedIn);
    console.info('[push] Listener userLoggedIn registrado');

    if (userService.isAuthenticated()) {
      console.info('[push] Usuário já autenticado ao montar — iniciando push (pedido de permissão em seguida)');
      runInit(loadConfig, registerDevice, hasInitialized);
    }

    return () => {
      window.removeEventListener('userLoggedIn', handleUserLoggedIn);
    };
  }, [loadConfig, registerDevice]);

  return null;
};

export default PushNotificationsInitializer;
